var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManageUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 25.4999H27.5V21.1769C27.4999 20.9771 27.4399 20.7819 27.3278 20.6165C27.2157 20.4511 27.0566 20.3231 26.871 20.2489L23.129 18.7489C22.9438 18.6749 22.7849 18.5472 22.6728 18.3822C22.5607 18.2172 22.5005 18.0224 22.5 17.8229V16.9449C23.1065 16.5969 23.6107 16.0952 23.9617 15.4905C24.3128 14.8857 24.4985 14.1992 24.5 13.4999V11.4999C24.5002 10.7977 24.3154 10.1078 23.9644 9.49961C23.6134 8.89141 23.1085 8.38633 22.5004 8.03515C21.8923 7.68397 21.2024 7.49906 20.5002 7.49902C19.798 7.49898 19.1081 7.68381 18.5 8.03492",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.871 21.249L15.129 19.749C14.9438 19.675 14.7849 19.5473 14.6728 19.3823C14.5607 19.2172 14.5005 19.0225 14.5 18.823V17.945C15.1065 17.5969 15.6107 17.0953 15.9617 16.4906C16.3128 15.8858 16.4985 15.1993 16.5 14.5V12.5C16.5 11.4391 16.0786 10.4217 15.3284 9.67157C14.5783 8.92143 13.5609 8.5 12.5 8.5C11.4391 8.5 10.4217 8.92143 9.67157 9.67157C8.92143 10.4217 8.5 11.4391 8.5 12.5V14.5C8.50153 15.1993 8.68717 15.8858 9.03826 16.4906C9.38935 17.0953 9.8935 17.5969 10.5 17.945V18.823C10.4999 19.0228 10.4399 19.218 10.3278 19.3834C10.2157 19.5488 10.0566 19.6769 9.871 19.751L6.129 21.251C5.94375 21.325 5.78488 21.4527 5.67279 21.6177C5.5607 21.7828 5.50053 21.9775 5.5 22.177V25.5H19.5V22.177C19.4999 21.9772 19.4399 21.782 19.3278 21.6166C19.2157 21.4512 19.0566 21.3231 18.871 21.249Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageUsers);
export default __webpack_public_path__ + "static/media/ManageUsers.0fba6360e4310e06af13c1124429898b.svg";
export { ForwardRef as ReactComponent };